var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1C3.46354 1 1 3.21369 1 5.94015C1 9.07732 4.66667 14.0488 6.01302 15.766C6.06891 15.8385 6.14215 15.8975 6.22679 15.9381C6.31142 15.9788 6.40504 16 6.5 16C6.59496 16 6.68858 15.9788 6.77321 15.9381C6.85785 15.8975 6.93109 15.8385 6.98698 15.766C8.33333 14.0496 12 9.07985 12 5.94015C12 3.21369 9.53646 1 6.5 1Z",
    stroke: "#606060",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50033 7.92362C7.51285 7.92362 8.33366 7.14869 8.33366 6.19277C8.33366 5.23684 7.51285 4.46191 6.50033 4.46191C5.4878 4.46191 4.66699 5.23684 4.66699 6.19277C4.66699 7.14869 5.4878 7.92362 6.50033 7.92362Z",
    stroke: "#606060",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.6c54456deda496ccd9658debdc25054f.svg";
export { ForwardRef as ReactComponent };